// extracted by mini-css-extract-plugin
export default {"dropContainer":"DropFilePDF_dropContainer__lUs9J","area":"DropFilePDF_area__Kxc8J","error":"DropFilePDF_error__551mf"};